import React from 'react'
import { treeInitialState, treeReducer } from './TreeReducer'

const TreeStateContext = React.createContext()
const TreeDispatchContext = React.createContext()

function useTreeState() {
  const context = React.useContext(TreeStateContext)
  if (context === undefined) {
    throw new Error('useTreeState must be used inside of TreeProvider')
  }
  return context
}

function useTreeDispatch() {
  const context = React.useContext(TreeDispatchContext)
  if (context === undefined) {
    throw new Error('useTreeDispatch must be used inside of TreeProvider')
  }
  return context
}

function TreeProvider({ children }) {
  const [state, dispatch] = React.useReducer(treeReducer, treeInitialState)

  return (
    <TreeStateContext.Provider value={state}>
      <TreeDispatchContext.Provider value={dispatch}>{children}</TreeDispatchContext.Provider>
    </TreeStateContext.Provider>
  )
}

export { TreeProvider, useTreeDispatch, useTreeState }
